import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import type { LinkHubCreatorAction } from './actions';
import {
  FETCH_ALL_LINK_COLLECTIONS,
  FETCH_ORIGINAL_WEB_URL_LINK_DATA,
  UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS,
} from './actions';
import { INIT_STATE } from './constants';
import type { LinkHubCreatorState } from './types';

const handler = (
  state: WrappedReducer<LinkHubCreatorState>,
  action: LinkHubCreatorAction
): WrappedReducer<LinkHubCreatorState> => {
  switch (action.type) {
    case FETCH_ORIGINAL_WEB_URL_LINK_DATA.response:
      return {
        ...state,
        originalWebUrlLinkData: action.data?.originalWebUrlLinkData,
      };
    case UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS.response:
      return {
        ...state,
        originalWebUrlLinkDataStatus: action.data?.originalWebUrlLinkDataStatus,
      };
    case FETCH_ALL_LINK_COLLECTIONS.response:
      return {
        ...state,
        allLinkCollections: action.data?.allLinkCollections,
      };
    default:
      return state;
  }
};

const LinkHubCreatorReducer = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [FETCH_ORIGINAL_WEB_URL_LINK_DATA, UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS, FETCH_ALL_LINK_COLLECTIONS],
  error: [FETCH_ORIGINAL_WEB_URL_LINK_DATA, UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS, FETCH_ALL_LINK_COLLECTIONS],
});

export default LinkHubCreatorReducer;
